<template>
  <div>
    <div v-show='!success'>
      <h5>Create New Account</h5>
      <div class="row">
        <input
          type="text"
          disabled
          v-model="entity.username"
          class="form-control col-md-4 offset-md-4 col-xs-12 my-2 px-2"
        >
        <input
          type="password"
          placeholder="Enter Password"
          v-model="entity.password"
          class="form-control col-md-4 offset-md-4 col-xs-12 my-2 px-2"
        >
        <input
          type="password"
          placeholder="Confirm Password"
          v-model="entity.confirm"
          class="form-control col-md-4 offset-md-4 col-xs-12 my-2 px-2"
        >
        <input
          type="text"
          placeholder="Enter First Name"
          v-model="entity.firstName"
          class="form-control col-md-4 offset-md-4 col-xs-12 my-2 px-2"
        >
        <input
          type="text"
          placeholder="Enter Last Name"
          v-model="entity.lastName"
          class="form-control col-md-4 offset-md-4 col-xs-12 my-2 px-2"
        >
        <div class="col-md-4 offset-md-4 col-xs-12 my-2 px-2">
          <ul style="color:red;">
            <li v-for="error in errors">{{error}}</li>
          </ul>
        </div>
        <div class="col-md-4 offset-md-4 col-xs-12 my-2 px-2">
          <button class="btn btn-primary btn-lg" v-on:click="register">Submit</button>
        </div>
      </div>
    </div>
    <div class='row' v-show='success'>
      <div class='col-md-4 offset-md-4 col-xs-12 my-5'>
        <p>Account has been created successfully!</p>

        <p class='my-5'>
          Useful links:
          <br>
          <button class='btn btn-link' v-on:click='linkMrs'>Ministry Recruitment System</button>
          
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../commons/http.js";
import config from "../config.js";

export default {
  data: function() {
    return {
      entity: {
        password: "",
        firstName: "",
        lastName: ""
      },
      errors: [],
      success:false,
      mrsAdminLoginUrl:config.mrsUrl()+"/#/adminlogin"
    };
  },
  methods: {
    linkMrs:function(){
      location.href = this.mrsAdminLoginUrl
    },
    register: async function() {
      if (this.validate() > 0) {
        return;
      }
      try {
        let response = await http.post("/register", this.entity);
        this.success = true;
      } catch (err) {
        console.log(err);
        this.errors.push(error.response.data.message);
      }
    },
    validate: function() {
      this.errors = [];
      if (this.entity.password.length < 6) {
        this.errors.push("Password must be at least 6 characters");
      } else if (this.entity.password !== this.entity.confirm) {
        this.errors.push("Password confirmation does not match");
      }

      if (this.entity.firstName.length === 0) {
        this.errors.push("First Name cannot be empty");
      }

      if (this.entity.lastName.length === 0) {
        this.errors.push("Last Name cannot be empty");
      }
      return this.errors.length;
    }
  },
  beforeMount: function() {
    this.entity.username = this.$route.query.username;
    this.entity.invitationToken = this.$route.query.token;
  }
};
</script>

<style>
</style>
